import { withPrep } from "../lib/issuer";
import React, { useState } from "react";
import { toast } from "sonner";
import { MessageSquare, Clock, Loader2, Send } from "lucide-react";
import { fmtDateTime } from "../lib/format";
import { qtyWithUnit } from "../lib/units";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

export default function RevisionRequestPanel({ negotiable, inRevision, revision, items, changes, onReset, onSend, issuerName = "Il Professionista" }) {
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const byId = Object.fromEntries((items || []).map((it) => [it.id, it]));

  if (inRevision) {
    const req = Object.values(revision?.quantities || {});
    return (
      <div data-testid="revision-pending-panel" className="rounded-xl border border-amber-300 bg-amber-50 p-5 mt-6">
        <p className="font-semibold text-amber-900 flex items-center gap-2"><Clock style={{ width: 16, height: 16 }} /> Richiesta inviata, attendi l'aggiornamento</p>
        <p className="text-sm text-amber-800 mt-1">{issuerName} sta rivedendo le quantità richieste{revision?.created_at ? ` il ${fmtDateTime(revision.created_at)}` : ""}. Riceverai un'email quando il preventivo sarà aggiornato.</p>
        {req.length > 0 && (
          <ul className="mt-3 text-sm space-y-1">
            {req.map((c, i) => <li key={i} className="text-amber-900"><strong>{c.title}</strong>: {qtyWithUnit(c.from, c.unit)} → <strong>{qtyWithUnit(c.to, c.unit)}</strong></li>)}
          </ul>
        )}
      </div>
    );
  }
  if (!negotiable) return null;

  const send = async () => {
    if (!changes.length) return toast.error("Modifica almeno una quantità");
    setBusy(true);
    try { await onSend({ message: message.trim(), name: name.trim() }); toast.success(`Richiesta inviata ${withPrep("a", issuerName)}!`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Invio non riuscito"); }
    setBusy(false);
  };

  return (
    <div data-testid="revision-request-panel" className="rounded-xl border border-indigo-200 bg-indigo-50/50 p-5 mt-6">
      <p className="font-semibold text-slate-900 flex items-center gap-2"><MessageSquare style={{ width: 16, height: 16 }} className="text-primary" /> Vuoi quantità diverse?</p>
      <p className="text-sm text-slate-600 mt-1">Usa i pulsanti +/− sulle voci modificabili per proporre quantità diverse: la proposta va approvata {withPrep("da", issuerName)} prima della firma.</p>
      {changes.length > 0 && (
        <ul className="mt-3 text-sm space-y-1" data-testid="revision-proposed-list">
          {changes.map(([id, v]) => (
            <li key={id}><strong>{byId[id]?.title}</strong>: {qtyWithUnit(byId[id]?.quantity, byId[id]?.unit)} → <strong className="text-amber-700">{qtyWithUnit(v, byId[id]?.unit)}</strong></li>
          ))}
        </ul>
      )}
      {changes.length > 0 ? (
        <>
      <div className="grid sm:grid-cols-[1fr,2fr] gap-2 mt-3">
        <Input data-testid="revision-name-input" placeholder="Il tuo nome (facoltativo)" value={name} onChange={(e) => setName(e.target.value)} />
        <Textarea data-testid="revision-message-input" rows={1} placeholder={`Messaggio per ${issuerName === "Il Professionista" ? "il Professionista" : issuerName} (facoltativo)`} value={message} onChange={(e) => setMessage(e.target.value)} />
      </div>
      <div className="flex gap-2 mt-3 flex-wrap">
        <Button data-testid="revision-send-button" onClick={send} disabled={busy} className="font-semibold whitespace-normal h-auto min-h-9 py-2 text-left w-full sm:w-auto">
          {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send style={{ width: 14, height: 14 }} className="mr-2" />} Richiedi aggiornamento / Conferma disponibilità
        </Button>
        <Button variant="outline" data-testid="revision-reset-button" onClick={onReset}>Ripristina</Button>
      </div>
        </>
      ) : (
        <p className="text-xs text-slate-500 mt-3" data-testid="revision-no-changes">Con le quantità originali puoi firmare subito il preventivo qui sotto.</p>
      )}
    </div>
  );
}
